import GenerateAPI from '../generate.js'
import utils from '@/utils/util'
let wConfig = utils.getConfig()
const config = {
    list: {
        url: '/client/necessary/list',
        apiType: 'check',
    },
    save: {
        url: '/pay/title/save',
    },
    submit: {
        url: '/client/necessary/submitOrder',
    },
    submitData: {
        url: '/client/necessary/submit/data',
        apiType: 'check',
    },
    data: {
        url: '/client/necessary/toPay/data',
        apiType: 'check',
    },
    check: {
        url: '/client/necessary/pay/check',
        apiType: 'check',
    },
    operate: {
        url: '/client/necessary/operate',
        apiType: 'check',
    },
    pay: {
        url: '/client/necessary/pay',
    },
    checkUnpay: {
        url: '/client/necessary/checkUnpay',
        apiType: 'check',
    }
}

const apiUnpaidFee = GenerateAPI.generate(config)
apiUnpaidFee.payPage = utils.isWeChatBrowser()||utils.isWorkWeChatBrowser()
    ? wConfig.VUE_APP_BASE_API + 'client/necessary/app/payPage'
    : wConfig.VUE_APP_BASE_API + '/client/necessary/payPage'
export default apiUnpaidFee
